import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ProductFields } from 'src/app/stores/seller-product.store';

@Component({
  selector: 'app-additional-information',
  templateUrl: './additional-information.page.html',
  styleUrls: ['./additional-information.page.scss'],
})
export class AdditionalInformationPage implements OnInit {
  productForm: FormGroup
  @Input() product_fields: Array<ProductFields>
  constructor(
    private formBuilder: FormBuilder,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.productForm = this.formBuilder.group({
      product_fields: this.formBuilder.array([]),
    })
    if (this.product_fields.length == 0) {
      this.addFields()
    } else {
      this.product_fields.forEach((field => {
        this.addFields(field)
      }))
    }
  }

  addFields(fieldOptions: ProductFields = null) {
    const piece = this.formBuilder.group({
      field_title: new FormControl(
        fieldOptions ? fieldOptions.field_title : '',
        Validators.compose([
          Validators.required
        ])
      ),
      field_input: new FormControl(
        fieldOptions ? fieldOptions.field_input : '',
        Validators.compose([
          Validators.required
        ])
      ),
      id: new FormControl(
        fieldOptions ? fieldOptions.id : '',
        Validators.compose([])
      ),
    });
    this.getProductFields.push(piece);
  }

  get getProductFields() {
    return (<FormArray>this.productForm.get('product_fields'));
  }

  saveInfo() {
    this.modalCtrl.dismiss(this.productForm.value)
  }

  async closeModal() {
    this.modalCtrl.dismiss()
  }

  removeFormRow(index: number) {
    this.getProductFields.removeAt(index)
  }

}
